import { createReducer } from '../helpers';
import { api } from '../actions';

const initialState = {
    socketId: null,
    isConnected: false,
    reconnected: 0,
};

export default createReducer(initialState, {
    [api.listenConnect]: (state, action) => {
        state.socketId = action.socketId;
        state.isConnected = true;
    },
    [api.listenDisconnect]: (state) => {
        state.socketId = null;
        state.isConnected = false;
    },
    [api.listenReconnect]: (state) => {
        state.reconnected++;
    },
});
